const nestedNode = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'nested',
        outputVars: {
          '': '',
        },
      },
    },
    type: 'integration',
  },
  paths: ['integration.name', 'integration.description', 'integration.endNode.outputVars.#'],
  groups: [
    {
      Parameters: ['integration.name', 'integration.description'],
    },
    {
      Logic: ['integration.endNode.outputVars.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    outputVars: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
        class: 'keyValuePairRow',
      },
      key: {
        type: 'text',
        label: '',
        placeholder: 'Key',
        validators: {
          required: false,
        },
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
        validators: {
          required: false,
        },
      },
    },
  },
  data: {
    outputVars: {
      '': '',
    },
  },
};

export const nestedEndNode: {} = {
  nested: nestedNode,
};
